export default {
  setIsNavbarShowing (state, isShowing) {
    state.isNavbarShowing = isShowing;
  },
  setIsConfigSet (state, isConfigSet) {
    state.isConfigSet = isConfigSet;
  },
};
